import { ApprovalStatus, ApprovalSubject, AssessmentEvaluationNote } from "../domain/ApprovalSubject";
import { RefQualificationLevelModel } from "../domain/RefQualificationLevelModel";
import { RefQualificationTypeModel } from "../domain/RefQualificationTypeMode";
import { SubjectModel } from "../domain/SubjectModel";

const formatSubjectDescriptionDisplay = (format: string): string => {
  const lastChar = format.trim().slice(-1);
  if (lastChar !== "" && lastChar !== ",") {
    return ", ";
  }

  return format;
};

export const subjectDescriptionDisplayAssessment = (
  approvalSubjects: ApprovalSubject[],
  furtherEvidenceMakingAssessments: string | undefined,
  furtherEvidenceStandardSetting: string | undefined,
  furtherEvidenceDesigningDevelopingAssessments: string | undefined,
  furtherEvidenceEvaluatingAssessments: string | undefined,
  levels: RefQualificationLevelModel[],
  subjects: SubjectModel[],
  qualTypes: RefQualificationTypeModel[]
): AssessmentEvaluationNote => {
  let makingAssessmentNote: string = "";
  let standardSettingNote: string = "";
  let designingDevelopingNote: string = "";
  let evaluatingNote: string = "";

  for (let sub of approvalSubjects) {
    for (let level of sub.levels) {
      if (
        furtherEvidenceMakingAssessments ||
        furtherEvidenceStandardSetting ||
        furtherEvidenceDesigningDevelopingAssessments ||
        furtherEvidenceEvaluatingAssessments
      ) {
        let matchingRefLevel = levels.find((l) => l.id === level.levelId);
        if (
          level?.evaluationResults?.makingAssessment?.approvalStatus ===
          ApprovalStatus.FurtherEvidence
        ) {
          let matchingSubject = subjects.find((s) => s.id === sub.subjectId);
          makingAssessmentNote += formatSubjectDescriptionDisplay(
            makingAssessmentNote
          );
          makingAssessmentNote += `${
            matchingSubject?.name
          } (${
            qualTypes.find((q) => q.id === matchingSubject?.qualificationTypeId)
              ?.description
          } - ${matchingRefLevel?.levelDescription})`;
        }

        if (
          level?.evaluationResults?.standardSetting?.approvalStatus ===
          ApprovalStatus.FurtherEvidence
        ) {
          standardSettingNote += formatSubjectDescriptionDisplay(
            standardSettingNote
          );
          let matchingSubject = subjects.find((s) => s.id === sub.subjectId);
          standardSettingNote += `${
            matchingSubject?.name
          } (${
            qualTypes.find((q) => q.id === matchingSubject?.qualificationTypeId)
              ?.description
          } - ${matchingRefLevel?.levelDescription})`;
        }

        if (
          level?.evaluationResults?.designingDevelopingAssessments
            ?.approvalStatus === ApprovalStatus.FurtherEvidence
        ) {
          designingDevelopingNote += formatSubjectDescriptionDisplay(
            designingDevelopingNote
          );
          let matchingSubject = subjects.find((s) => s.id === sub.subjectId);
          designingDevelopingNote += `${
            matchingSubject?.name
          } (${
            qualTypes.find((q) => q.id === matchingSubject?.qualificationTypeId)
              ?.description
          } - ${matchingRefLevel?.levelDescription})`;
        }

        if (
          level?.evaluationResults?.evaluatingAssessments?.approvalStatus ===
          ApprovalStatus.FurtherEvidence
        ) {
          evaluatingNote += formatSubjectDescriptionDisplay(
            evaluatingNote
          );
          let matchingSubject = subjects.find((s) => s.id === sub.subjectId);
          evaluatingNote += `${
            matchingSubject?.name
          } (${
            qualTypes.find((q) => q.id === matchingSubject?.qualificationTypeId)
              ?.description
          } - ${matchingRefLevel?.levelDescription})`;
        }
      }
    }
  }

  const additionalNote: AssessmentEvaluationNote = {
    makingAssessmentFurtherEvidenceGeneratedNote: makingAssessmentNote,
    designingDevelopingAssessmentFurtherEvidenceGeneratedNote: designingDevelopingNote,
    evaluatingAssessmentsFurtherEvidenceGeneratedNote: evaluatingNote,
    standardSettingFurtherEvidenceGeneratedNote: standardSettingNote,
  }
  return additionalNote;
};

export const subjectDescriptionDisplayTeaching = (
  approvalSubjects: ApprovalSubject[],
  furtherEvidenceTeachingLecturingAssessment: string | undefined,
  furtherEvidenceTrainingAssessment: string | undefined,
  furtherEvidenceEducationManagementAssessment: string | undefined,
  furtherEvidenceTeacherTrainingAssessment: string | undefined,
  levels: RefQualificationLevelModel[],
  subjects: SubjectModel[],
  qualTypes: RefQualificationTypeModel[]
): AssessmentEvaluationNote => {
  let teachingLecturingNote: string = "";
  let trainingAssessmentNote: string = "";
  let educationManagementAssessmentNote: string = "";
  let teacherTrainingAssessmentNote: string = "";

  for (let sub of approvalSubjects) {
    for (let level of sub.levels) {
      if (
        furtherEvidenceTeachingLecturingAssessment ||
        furtherEvidenceTrainingAssessment ||
        furtherEvidenceEducationManagementAssessment ||
        furtherEvidenceTeacherTrainingAssessment
      ) {
        let matchingRefLevel = levels.find((l) => l.id === level.levelId);
        if (
          level?.evaluationResults?.teachingLecturingAssessment?.approvalStatus ===
          ApprovalStatus.FurtherEvidence
        ) {
          let matchingSubject = subjects.find((s) => s.id === sub.subjectId);
          teachingLecturingNote += formatSubjectDescriptionDisplay(
            teachingLecturingNote
          );
          teachingLecturingNote += `${
            matchingSubject?.name
          } (${
            qualTypes.find((q) => q.id === matchingSubject?.qualificationTypeId)
              ?.description
          } - ${matchingRefLevel?.levelDescription})`;
        }

        if (
          level?.evaluationResults?.trainingAssessment?.approvalStatus ===
          ApprovalStatus.FurtherEvidence
        ) {
          trainingAssessmentNote += formatSubjectDescriptionDisplay(
            trainingAssessmentNote
          );
          let matchingSubject = subjects.find((s) => s.id === sub.subjectId);
          trainingAssessmentNote += `${
            matchingSubject?.name
          } (${
            qualTypes.find((q) => q.id === matchingSubject?.qualificationTypeId)
              ?.description
          } - ${matchingRefLevel?.levelDescription})`;
        }

        if (
          level?.evaluationResults?.educationManagementAssessment?.approvalStatus === ApprovalStatus.FurtherEvidence
        ) {
          educationManagementAssessmentNote += formatSubjectDescriptionDisplay(
            educationManagementAssessmentNote
          );
          let matchingSubject = subjects.find((s) => s.id === sub.subjectId);
          educationManagementAssessmentNote += `${
            matchingSubject?.name
          } (${
            qualTypes.find((q) => q.id === matchingSubject?.qualificationTypeId)
              ?.description
          } - ${matchingRefLevel?.levelDescription})`;
        }

        if (
          level?.evaluationResults?.teacherTrainingAssessment?.approvalStatus ===
          ApprovalStatus.FurtherEvidence
        ) {
          teacherTrainingAssessmentNote += formatSubjectDescriptionDisplay(
            teacherTrainingAssessmentNote
          );
          let matchingSubject = subjects.find((s) => s.id === sub.subjectId);
          teacherTrainingAssessmentNote += `${
            matchingSubject?.name
          } (${
            qualTypes.find((q) => q.id === matchingSubject?.qualificationTypeId)
              ?.description
          } - ${matchingRefLevel?.levelDescription})`;
        }
      }
    }
  }

  const additionalNote: AssessmentEvaluationNote = {
    teachingLecturingFurtherEvidenceGeneratedNote: teachingLecturingNote,
    trainingFurtherEvidenceGeneratedNote: trainingAssessmentNote,
    educationManagementFurtherEvidenceGeneratedNote: educationManagementAssessmentNote,
    teacherTrainingFurtherEvidenceGeneratedNote: teacherTrainingAssessmentNote,
  }
  return additionalNote;
};

export const subjectDescriptionDisplayIndustry = (
  approvalSubjects: ApprovalSubject[],
  furtherEvidenceIndustryAssessment: string | undefined,
  levels: RefQualificationLevelModel[],
  subjects: SubjectModel[],
  qualTypes: RefQualificationTypeModel[]
): AssessmentEvaluationNote => {
  let subjectDescription: string = "";

  for (let sub of approvalSubjects) {
    for (let level of sub.levels) {
      if (
        furtherEvidenceIndustryAssessment
      ) {
        let matchingRefLevel = levels.find((l) => l.id === level.levelId);
        if (
          level?.evaluationResults?.industryAssessment?.approvalStatus ===
          ApprovalStatus.FurtherEvidence
        ) {
          let matchingSubject = subjects.find((s) => s.id === sub.subjectId);
          subjectDescription += formatSubjectDescriptionDisplay(
            subjectDescription
          );
          subjectDescription += `${
            matchingSubject?.name
          } (${
            qualTypes.find((q) => q.id === matchingSubject?.qualificationTypeId)
              ?.description
          } - ${matchingRefLevel?.levelDescription})`;
        }
      }
    }
  }

  return {
    industryFurtherEvidenceNote: subjectDescription
  };
};
